// Module
var code = "<div\n  :style=\"overlayStyle\"\n  v-on:touchstart=\"onTouchStart\"\n  v-on:touchend=\"onTouchEnd\"\n>\n  <playback-controls\n    v-if=\"playbackControlsEnabled\"\n    v-bind:content=\"content\"\n  ></playback-controls>\n</div>\n";
// Exports
export default code;